// This icon file is generated automatically.
var PSearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.21 12.35L9.15 8.3a4.65 4.65 0 00-.4-6.17 4.65 4.65 0 00-6.63 0 4.65 4.65 0 000 6.63 4.65 4.65 0 006.17.4l4.06 4.06c.05.05.13.05.18 0l.68-.68a.13.13 0 000-.18zm-5.3-4.44a3.48 3.48 0 01-4.95 0 3.48 3.48 0 010-4.95 3.48 3.48 0 014.95 0 3.48 3.48 0 010 4.95z", "fill-rule": "nonzero" } }] }, "name": "p-search", "theme": "outlined" };
export default PSearchOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSearchOutlined.js
// module id = 3616
// module chunks = 0